module.exports = __webpack_public_path__ + "static/media/dustBinIcon.3fca7453.svg";